export enum PaymentRoute {
  Index = '/payment',
  Save = '/payment/save'
}
